import { Post } from '@/core/services/interfaces/PostInterfaces';

export const MOCK_EXISTING_TAGS: string[] = [
  'filmes',
  '06 CRI -- IP | IG |CONSIDERAÇÃO | Minhas Vantagens Menu Manimanioca dark 1 visualização',
  'cinema',
  'diversao',
  'tecnologia',
  'inovação',
  'Artes & Entretenimento',
  'QA',
  'Engenharia',
  'Sucesso',
  'Viral',
  'Design',
  'Frontend',
  'Debug',
];

export const MOCK_EXISTING_GROUPS: string[] = [
  'NotíciasDoOscar',
  'TechNews',
  'Tudimtôtim',
  'DebugTeam',
  'Mídias Sociais',
  'Entretenimento Geral',
];

export const MOCK_EXISTING_THEMES: string[] = [
  'Oscar26',
  'Innovation',
  'Artes & Entretenimento',
  'Maintenance',
  'Tendências',
  'Tecnologia',
];

export const MOCK_EXISTING_INTERESTS: string[] = [
  'Cinema',
  'Tecnologia',
  'Entretenimento',
  'Humor',
  'Esportes',
  'Política',
];


export const MOCK_POSTS: Post[] = [
  {
    _id: '1',
    pid: '1',
    primary_channel: 'instagram',
    channel: 'Comentários do Instagram',
    name: 'Adoro Cinema nome muito grande para verificar espaçamento',
    title: 'Aqui vai um título do card',
    text: 'Lorem ipsum dolor sit amet, consectetur <b>adipiscing elit</b>. Phasellus sagittis tellus a lorem mollis, et tristique erat vulputate. Donec justo nunc, elementum ac diam a, sagittis blandit erat. Mauris vel suscipit lorem. Curabitur dapibus odio et bibendum elementum. Etiam vehicula vel justo pulvinar pulvinar. Curabitur hendrerit aliquet leo, eget suscipit dolor euismod id. Donec vehicula tempus euismod. In et quam vulputate metus congue vehicula. Suspendisse vehicula sapien in porta imperdiet. Pellentesque varius urna ac mi feugiat, vel dignissim mi sodales. Mauris sit amet nibh eros. Pellentesque auctor quam ligula, eu scelerisque sem porta vitae. Pellentesque quis leo lacinia tellus tempor consectetur. Nam eleifend fermentum felis, nec varius sapien blandit vitae. Donec sit amet aliquam justo, eu volutpat orci. Duis luctus porttitor erat, in laoreet augue venenatis sed. Donec ac felis vehicula, malesuada erat vel, condimentum sapien. Praesent ultrices ligula eu nulla feugiat, quis feugiat dolor lacinia. Suspendisse laoreet est quis arcu finibus, id lacinia lorem lacinia. Vivamus odio diam, posuere ac eleifend a, blandit at velit. Quisque <b>efficitur</b> sit amet risus nec suscipit.',
    hashtags: ['06 CRI -- IP | IG |CONSIDERAÇÃO | Minhas Vantagens Menu Manimanioca dark 1 visualização', 'wagnermoura', 'oscar', 'premiacao', 'brasil', 'filme estrangeiro', 'aqui', 'agora', '06 CRI -- IP | IG |CONSIDERAÇÃO | Minhas Vantagens Menu Manimanioca dark 1 visualização'],
    tags: ['06 CRI -- IP | IG |CONSIDERAÇÃO | Minhas Vantagens Menu Manimanioca dark 1 visualização', 'cinema', 'diversao', 'teste1', 'teste2', 'teste3', 'teste4', 'teste5', 'teste6', 'teste7', 'teste8', 'teste9', 'teste10'],
    likes: 81,
    shares: 2,
    comments: 4,
    videoplays: 0,
    followers: 1500,
    posted_at: '2025-12-29T10:00:00Z',
    metrics_updated_at: '29/12/2025',
    update_time_ago: 'há 2 horas',
    lang: 'pt',
    names: ['NotíciasDoOscar'],
    themes: ['Oscar26'],
    post_user_image_url: 'https://instagram.com/post/1',
    gender: 'Homem',
    polarity: 1,
    verified: true,
    post_url: 'https://instagram.com/p/ABC123',
    occupations: ['Cinema'],
    isHotPost: true,
    computer_vision: {
      text: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sagittis tellus a lorem mollis, et tristique erat vulputate. Donec justo nunc, elementum ac diam a, sagittis blandit erat. Mauris vel suscipit lorem.'
    }
  },
  {
    _id: '2',
    pid: '2',
    primary_channel: 'facebook',
    channel: 'facebook',
    name: 'Stilingue',
    text: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    hashtags: ['AI', 'Tech', 'Frontend'],
    tags: ['tecnologia', 'inovação'],
    likes: 138750,
    shares: 138750,
    comments: 138750,
    videoplays: 138750,
    followers: 138750,
    posted_at: '2025-12-30T15:30:00Z',
    metrics_updated_at: '30/12/2025',
    update_time_ago: 'há 1 dia',
    lang: 'pt',
    names: ['TechNews'],
    themes: ['Innovation'],
    post_user_image_url: 'https://facebook.com/post/2',
    image_url: 'https://blog.luminef.tv/wp-content/uploads/2026/01/indicados-ao-oscar-2026-460490-1277x574.jpg',
    gender: 'Mulher',
    polarity: 0,
    verified: true,
    post_url: 'https://facebook.com/posts/DEF456',
    occupations: ['Tecnologia'],
    sac_type: 'Mention',
    computer_vision: {
      text: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sagittis tellus a lorem mollis, et tristique erat vulputate. Donec justo nunc, elementum ac diam a, sagittis blandit erat. Mauris vel suscipit lorem.'
    }
  },
  {
    _id: '3',
    primary_channel: 'youtube',
    channel: 'YouTube',
    name: 'testeteste',
    text: 'The Oscar Nominees were announced this morning and there were some big surprises, Cleto Sr. made a tortilla that looked just like Donald Trump this...',
    hashtags: ['kimmel', 'oscar2026', 'academyawards'],
    tags: ['Artes & Entretenimento'],
    likes: 138750,
    shares: 138750,
    comments: 138750,
    videoplays: 138750,
    followers: 138750,
    posted_at: '2026-01-23T07:38:00Z',
    metrics_updated_at: '23/01/2026',
    update_time_ago: 'há 5 minutos',
    lang: 'en',
    names: ['Tudimtôtim'],
    themes: ['Artes & Entretenimento'],
    post_user_image_url: 'https://www.youtube.com/watch?v=4lLrYdL--Xc',
    image_url: 'https://i.ytimg.com/vi/4lLrYdL--Xc/maxresdefault.jpg',
    gender: 'Marca',
    polarity: 2,
    post_url: 'https://youtube.com/watch?v=GHI789',
    occupations: ['Entretenimento', 'Cinema', 'Humor'],
    isCrossPost: true,
  },
  {
    _id: '4',
    primary_channel: 'youtube',
    channel: 'YouTube',
    name: 'Jimmy Kimmel Live',
    text: 'The <b>Oscar</b> Nominees were announced this morning and there were some big surprises, Cleto Sr. made a tortilla that looked just like Donald Trump this...',
    hashtags: ['kimmel', 'oscar2026', 'academyawards'],
    tags: ['Artes & Entretenimento'],
    likes: 126000,
    shares: 10000000003,
    comments: 6000,
    videoplays: 5000000,
    followers: 22000000,
    posted_at: '2026-01-23T07:38:00Z',
    metrics_updated_at: '23/01/2026',
    update_time_ago: 'há 5 minutos',
    lang: 'en',
    names: ['Tudimtôtim'],
    themes: ['Artes & Entretenimento'],
    post_user_image_url: 'https://www.youtube.com/watch?v=4lLrYdL--Xc',
    image_url: 'https://i.ytimg.com/vi/4lLrYdL--Xc/maxresdefault.jpg',
    post_url: 'https://youtube.com/watch?v=JKL012',
  },
  {
    _id: '5',
    primary_channel: 'twitter',
    channel: 'Twitter',
    name: 'Jimmy Kimmel Live',
    text: 'The <b>Oscar</b> Nominees were announced this morning and there were some big surprises, Cleto Sr. made a tortilla that looked just like Donald Trump this...',
    hashtags: ['kimmel', 'oscar2026', 'academyawards'],
    tags: ['Artes & Entretenimento'],
    likes: 126000,
    shares: 10000000003,
    comments: 6000,
    videoplays: 5000000,
    followers: 22000000,
    posted_at: '2026-01-23T07:38:00Z',
    metrics_updated_at: '23/01/2026',
    update_time_ago: 'há 5 minutos',
    lang: 'en',
    names: ['Tudimtôtim'],
    themes: ['Artes & Entretenimento'],
    post_user_image_url: 'https://www.youtube.com/watch?v=4lLrYdL--Xc',
    image_url: 'https://i.ytimg.com/vi/4lLrYdL--Xc/maxresdefault.jpg',
    post_url: 'https://youtube.com/watch?v=JKL012',
  },
  {
    _id: '6',
    primary_channel: 'youtube',
    channel: 'YouTube',
    name: 'Dados Indisponíveis',
    text: 'Testando o comportamento do componente quando todos os dados retornam nulos da API para verificar o texto de noData.',
    hashtags: ['test', 'null', 'debug'],
    tags: ['QA', 'Engenharia'],
    likes: 0,
    shares: 0,
    comments: 0,
    videoplays: 0,
    followers: 0,
    posted_at: '2026-03-20T10:00:00Z',
    metrics_updated_at: '20/03/2026',
    update_time_ago: 'há 1 hora',
    lang: 'pt',
    names: ['DebugTeam'],
    themes: ['Maintenance'],
    post_user_image_url: 'https://youtube.com/watch?v=nullcase',
    post_url: 'https://youtube.com/watch?v=MNO345',
  },
  {
    _id: '7',
    primary_channel: 'youtube',
    channel: 'YouTube',
    name: 'Canal Bilionário',
    text: 'Testando números na casa dos bilhões para ver se a sigla B e os decimais cabem no novo layout espremido de 62px.',
    hashtags: ['billion', 'views', 'trending'],
    tags: ['Sucesso', 'Viral'],
    likes: 1200000000,
    shares: 1100000000,
    comments: 1500000000,
    videoplays: 2800000000,
    followers: 5000000000,
    posted_at: '2026-03-21T12:00:00Z',
    metrics_updated_at: '21/03/2026',
    update_time_ago: 'há 12 horas',
    lang: 'en',
    names: ['GlobalStats'],
    themes: ['Economy'],
    post_user_image_url: 'https://youtube.com/watch?v=billions',
    post_url: 'https://youtube.com/watch?v=PQR678',
  },
  {
    _id: '8',
    primary_channel: 'youtube',
    channel: 'YouTube',
    name: 'Misto Extremo',
    text: 'Um valor muito alto (138.8K) e o restante zerado para testar o desequilíbrio visual no flexbox row.',
    hashtags: ['mix', 'stats', 'layout'],
    tags: ['Design', 'Frontend'],
    likes: 138800,
    shares: 0,
    comments: 0,
    videoplays: 0,
    followers: 0,
    posted_at: '2026-03-22T08:30:00Z',
    metrics_updated_at: '22/03/2026',
    update_time_ago: 'há 2 dias',
    lang: 'es',
    names: ['UI_Testing'],
    themes: ['Visual'],
    post_user_image_url: 'https://youtube.com/watch?v=mixedstats',
    post_url: 'https://youtube.com/watch?v=STU901',
  },
  {
    _id: '1494144818966742_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1494144818966742',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1494144818966742/1494144818966742',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1494144818966742/1494144818966742?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=WcfYg4PP2TscKCZVhxwTpxNxutbBRLSnr9%2Blu9qFtaeobL%2Bw1W1Gdg9KdJoovCQCDIXHfgABfuLyudTjAdLY0ZEp5D%2Bw%2B4a2uhCv6rAkoDfvdkhfwUmtWJMjApauKLpqn7bflMBADGis09DNhUb6yZ2OGzdphbz10R2mjC1NGQM%2FVQGJn2x%2B7bFYUTkaUx0RAn%2BA3TneaVnwf4c%2F8y%2B1JsTaH7VIh%2F%2FVJyuB70iUCR43Hu2CDTl%2BPBiIxUr4NpXLQE%2BBYjWNPSOoP1JnotnrQkmPAPQDNXiUucSwbXdQKnfp%2FeRXFMPkFIdYlg4WDVLy2l975AsBnB2Sft8Qkel4zw%3D%3D',
        type: 'image/jpeg',
        url: 'https://scontent-iad3-2.xx.fbcdn.net/v/t15.5256-10/665466024_1212690784403149_285260321473165030_n.jpg?stp=dst-jpg_s720x720_tt6&_nc_cat=111&ccb=1-7&_nc_sid=5fad0e&_nc_eui2=AeH9W_jn5_4Z7QIzByfJs8C_CGLb5q4oMygIYtvmrigzKGR64bjyXNOteviBEBVdmhW9aLZ-cf9DhKIvBx04fnQC&_nc_ohc=mFxeG3X29ugQ7kNvwGz9Nth&_nc_oc=Adqj8c9Z35OdEw4-72gh19-gUFEiWVAAphpMGO3Nu2Moyx3pCGJK3tbz0oZx1fjnlyM&_nc_zt=23&_nc_ht=scontent-iad3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=Fv4QInLronEVlImdyOnb4g&_nc_tpa=Q5bMBQH9jaxiSy5gZkYwEVknYv8N_M4uCyVa0-S2ytYyC8ZdfOBDbyM34UD_H56evesD669lPgghJ2eE&oh=00_Af20fyauh1r6S4FJb6AJpGRh-IyQZGMKzAZo5NbukTanwA&oe=69D59ADC'
      },
    ],
    authors: [],
    channel: 'Facebook',
    comments: 2,
    computer_vision: {
      has_image_text: true,
      text: 'caliburn que nadarataca nada ataca'
    },
    contact_reasons: [],
    crawled_at: 1775228046098,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: '',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [
      '#mamifero',
      '#fatosdesconhecidos',
      '#roedor',
      '#capivara',
      '#curiosidades'
    ],
    hidden_by_user: false,
    hot: 2675.278928596617,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1494144818966742/1494144818966742?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=WcfYg4PP2TscKCZVhxwTpxNxutbBRLSnr9%2Blu9qFtaeobL%2Bw1W1Gdg9KdJoovCQCDIXHfgABfuLyudTjAdLY0ZEp5D%2Bw%2B4a2uhCv6rAkoDfvdkhfwUmtWJMjApauKLpqn7bflMBADGis09DNhUb6yZ2OGzdphbz10R2mjC1NGQM%2FVQGJn2x%2B7bFYUTkaUx0RAn%2BA3TneaVnwf4c%2F8y%2B1JsTaH7VIh%2F%2FVJyuB70iUCR43Hu2CDTl%2BPBiIxUr4NpXLQE%2BBYjWNPSOoP1JnotnrQkmPAPQDNXiUucSwbXdQKnfp%2FeRXFMPkFIdYlg4WDVLy2l975AsBnB2Sft8Qkel4zw%3D%3D',
    impact: 0,
    interacted_page_id: '451836741536694',
    interactions: 40,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 36,
    location: '',
    long_posted_at: 1775227832000,
    long_updated_at: 1775231802718,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [
      '#fatosdesconhecidos',
      '#curiosidades',
      '#mamifero',
      '#capivara',
      '#roedor'
    ],
    metrics_updated_at: '03/04/2026 11:54',
    name: 'Fatos Desconhecidos',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '451836741536694',
    pages: [
      '451836741536694'
    ],
    pid: '1494144818966742',
    polarity: 0,
    post_url: 'https://www.facebook.com/reel/961524936360434/',
    post_user_image_url: 'https://scontent-iad6-1.xx.fbcdn.net/v/t39.30808-1/287011475_7320776464642653_8482837033843384834_n.jpg?stp=cp0_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeGYNjz4RZ9rzUsxDclg7u_m6uXV-Pveacbq5dX4-95pxkmYEcbiUlX--OR0H-g2AxDHpuJZnHt-b_BWyc8o0s-p&_nc_ohc=ert5SH4xligQ7kNvwFG1xLO&_nc_oc=AdrlxtDyt-qm_9iPCW7FBlnb0Hva51YvyfwtsEZ67Ypz9-IXs7FSqG4jS982WTye118&_nc_zt=24&_nc_ht=scontent-iad6-1.xx&edm=AKIiGfEEAAAA&_nc_gid=Fv4QInLronEVlImdyOnb4g&_nc_tpa=Q5bMBQEEW1q9RsNJvL2KFRvCeFQyN5R1YbLl0bK7zO_TfZnMM-00M8fzDQa7vkMJJxd7el3d25LateOq&oh=00_Af0O33W2U0k-rJa9MKijPZxH4YumkobdTVK7iXpVRkGQdg&oe=69D594D9',
    posted_at: '03/04/2026 11:50',
    primary_channel: 'Facebook',
    reaction_angry: 0,
    reaction_haha: 0,
    reaction_like: 36,
    reaction_love: 1,
    reaction_pride: 0,
    reaction_sad: 1,
    reaction_thankful: 0,
    reaction_total: 38,
    reaction_wow: 0,
    reactions: 38,
    replied: false,
    reply_pid: '1494144818966742',
    shares: 0,
    spam: true,
    spokesman: [],
    status: 'Pendente',
    tags: [
      'IMAGE-RECOGNITION-SERVICE'
    ],
    terms: [],
    text: 'Por que nenhum animal ataca a <b>capivara</b>?<br><br>#curiosidades #fatosdesconhecidos #<b>capivara</b> #roedor #mamifero',
    theme_polarity: [],
    themes: [],
    title: '',
    type: 'video',
    uid: '451836741536694',
    update_time_ago: '1 m\u00eas atr\u00e1s',
    user_image_url: 'https://scontent-iad6-1.xx.fbcdn.net/v/t39.30808-1/287011475_7320776464642653_8482837033843384834_n.jpg?stp=cp0_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeGYNjz4RZ9rzUsxDclg7u_m6uXV-Pveacbq5dX4-95pxkmYEcbiUlX--OR0H-g2AxDHpuJZnHt-b_BWyc8o0s-p&_nc_ohc=ert5SH4xligQ7kNvwFG1xLO&_nc_oc=AdrlxtDyt-qm_9iPCW7FBlnb0Hva51YvyfwtsEZ67Ypz9-IXs7FSqG4jS982WTye118&_nc_zt=24&_nc_ht=scontent-iad6-1.xx&edm=AKIiGfEEAAAA&_nc_gid=Fv4QInLronEVlImdyOnb4g&_nc_tpa=Q5bMBQEEW1q9RsNJvL2KFRvCeFQyN5R1YbLl0bK7zO_TfZnMM-00M8fzDQa7vkMJJxd7el3d25LateOq&oh=00_Af0O33W2U0k-rJa9MKijPZxH4YumkobdTVK7iXpVRkGQdg&oe=69D594D9',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/451836741536694',
    username: 'Desconhecidos.Fatos',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '1568406534843618_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1568406534843618',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1568406534843618/1568406534843618',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1568406534843618/1568406534843618?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=XD3aTgI8sQKmq60oroQAtBur8ZX33oOej1mwlrhXrA3WG2eoquF1IfKH1YJwc5GGKQmNh%2FmwMkhcJmKeHIowEP83n0B5xPNlGj9Jpw4364TslS2px%2FTjYF%2B0O0Wq1YtBU%2FayDVdiP2V%2F%2BrBwc7FwkWHXd00E%2FzIv6tJB0yy%2FtEhIj3%2F%2BAb5qGJPKmspYlEMj26Bkemm6vs4vLTsVWeKJ92vkxBtexOhVHCZgtviIfz%2BDtEK8XQQanr6vDNWsXAz48y8g6swGWd1lrVtALrqafCuz15s4ZnZ90v41hh2OYUZMlmQ5SAjvjY6MDdHVIjEBhlfzWurAXKmBdjSRMrmelw%3D%3D',
        type: 'image/jpeg',
        url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t51.82787-15/656719913_18636156427060946_2260460077142794339_n.webp?stp=dst-jpg_p720x720_tt6&_nc_cat=1&ccb=1-7&_nc_sid=13d280&_nc_eui2=AeFktO1opJ_l6PVaQs34DcgrYpI0jXfnIS1ikjSNd-chLRrIbbH0Xvaw5WhAxg494D024cZLvoIEtqSNTHUJ-7l8&_nc_ohc=F7n4CjhMYuMQ7kNvwEB0np8&_nc_oc=AdpAirQpb_EvPSBK85bDRi2WjYffVDNS2OpEK0UX5JmPkHVkEZ_UddfjtiZyG4o01Mg&_nc_zt=23&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGktNUEU9N0TeGuVuYPWDhKF4tZglkP54b6Ml73gzP7xFuh_MgURLctcTAhXO4r1z1Q1figlS0z&oh=00_Afy6I0uLJ-fETaBj-0sbNd1V6S0Vm6fVTUFI5TBVQ2OOtg&oe=69C90028'
      }
    ],
    authors: [],
    channel: 'Facebook',
    comments: 11,
    computer_vision: {
      has_image_text: true,
      text: '21 v0372026 01119 01 19 homens acusados de espancar <b>capivara</b> no rj sao enquadrados no decreto cao orelha e ibama anuncia medida hugo gloss m 14'
    },
    contact_reasons: [],
    crawled_at: 1774396817926,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: 'Homem',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [],
    hidden_by_user: false,
    hot: 2671.371963912706,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1568406534843618/1568406534843618?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=XD3aTgI8sQKmq60oroQAtBur8ZX33oOej1mwlrhXrA3WG2eoquF1IfKH1YJwc5GGKQmNh%2FmwMkhcJmKeHIowEP83n0B5xPNlGj9Jpw4364TslS2px%2FTjYF%2B0O0Wq1YtBU%2FayDVdiP2V%2F%2BrBwc7FwkWHXd00E%2FzIv6tJB0yy%2FtEhIj3%2F%2BAb5qGJPKmspYlEMj26Bkemm6vs4vLTsVWeKJ92vkxBtexOhVHCZgtviIfz%2BDtEK8XQQanr6vDNWsXAz48y8g6swGWd1lrVtALrqafCuz15s4ZnZ90v41hh2OYUZMlmQ5SAjvjY6MDdHVIjEBhlfzWurAXKmBdjSRMrmelw%3D%3D',
    impact: 0,
    interacted_page_id: '196008906145',
    interactions: 87,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 55,
    location: '',
    long_posted_at: 1774395894000,
    long_updated_at: 1774396828407,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [],
    metrics_updated_at: '24/03/2026 21:00',
    name: 'Hugo Gloss',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '196008906145',
    pages: [
      '196008906145'
    ],
    pid: '1568406534843618',
    polarity: 0,
    post_url: 'https://www.facebook.com/858693865814892/posts/1568406534843618',
    post_user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    posted_at: '24/03/2026 20:44',
    primary_channel: 'Facebook',
    reaction_angry: 8,
    reaction_haha: 0,
    reaction_like: 55,
    reaction_love: 1,
    reaction_pride: 0,
    reaction_sad: 9,
    reaction_thankful: 0,
    reaction_total: 74,
    reaction_wow: 1,
    reactions: 74,
    replied: false,
    reply_pid: '1568406534843618',
    shares: 2,
    spam: false,
    spokesman: [],
    status: 'Pendente',
    tags: [
      'IMAGE-RECOGNITION-SERVICE'
    ],
    terms: [],
    text: 'Os homens presos pelo espanc*mento de uma <b>capivara</b>, na zona norte do Rio de Janeiro, foram enquadrados no Decreto C\u00e3o Orelha. O Ibama tamb\u00e9m anunciou medidas mais severas ap\u00f3s a atualiza\u00e7\u00e3o das normas sobre crimes ambientais e maus-tratos pelo governo federal. Al\u00e9m disso, os valores das multas para esses delitos foram alterados. Os seis suspeitos continuam presos.<br><br>\u27a1\ufe0f Saiba os detalhes, clicando aqui: https://gloss.bz/41pMSt1<br><br>(\ud83d\udcf8: Divulga\u00e7\u00e3o/PMERJ; Reprodu\u00e7\u00e3o/TV Globo)<br><br>Fotos do post de Hugo Gloss',
    theme_polarity: [],
    themes: [],
    title: 'Fotos do post de Hugo Gloss',
    type: 'image',
    uid: '196008906145',
    update_time_ago: '2 meses atrás',
    user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/196008906145',
    username: 'HugoGloss',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '1568404514843820_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1568404514843820',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1568404514843820/1568404514843820',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1568404514843820/1568404514843820?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=f4RR6DlIz92SHdiBHULAR8syOxV6c16%2FiEuv3CghEWpbgEeFEmTZvLifQKYG72T3srr51FhsPjMKFFKjlP7fQrMIyyHBz3VkmskzlhpwMuGZb4usb1eBNcoHrem9VtNxwdxdW%2BhwcaVKMnwKM1UY9PMZZj4XyaB1yCAIgDMsXHJXRAANbq%2BAmetlLu0BzRyTYnmk4NjRbi0%2FLtgPt76UYiv2zJW06SpKlzkwtGyNSEeZ4EHt%2BC14yYroybU4tDHPjnjpGt1%2FS1JLEHI%2BEIefBRuPsNFh9XQeG0oPEuQGHydZvdlBhkBDbkyYT9DTzOuES1suOlukXmWn4Qo168OuqA%3D%3D',
        type: 'image/jpeg',
        url: 'https://external-mia3-2.xx.fbcdn.net/emg1/v/t13/8485389942037412485?url=https%3A%2F%2Fmedia.hugogloss.uol.com.br%2Fuploads%2F2026%2F03%2FHEAD-HG-1-29-617x347.png&fb_obo=1&utld=uol.com.br&stp=c0.5000x0.5000f_dst-emg0_p347x347_q75_tt6&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_eui2=AeFJ4X9JyihkY3JwIwVNsKWjKYa-8niVB_Aphr7yeJUH8GEbwqLFbXfGsNLLsn97ai4qPSZDlW203T8-Ot7-3Fcn&_nc_oc=AdoXciS8TA-h4RwBz7PYaSvJKa7lwFTjCV-KQwL_IE8g0UwTUkum7iVUmTFJz-A4bMY&ccb=13-1&oh=06_Q3-9ARvF6sfvTL2bx6rkpNxT-45IrwTqmM2AJYu3uoUlE-b0&oe=69C51BBE&_nc_sid=ef6713'
      }
    ],
    authors: [],
    channel: 'Facebook',
    comments: 2,
    contact_reasons: [],
    crawled_at: 1774396817926,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: 'Homem',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [],
    hidden_by_user: false,
    hot: 2671.2372850043357,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1568404514843820/1568404514843820?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=f4RR6DlIz92SHdiBHULAR8syOxV6c16%2FiEuv3CghEWpbgEeFEmTZvLifQKYG72T3srr51FhsPjMKFFKjlP7fQrMIyyHBz3VkmskzlhpwMuGZb4usb1eBNcoHrem9VtNxwdxdW%2BhwcaVKMnwKM1UY9PMZZj4XyaB1yCAIgDMsXHJXRAANbq%2BAmetlLu0BzRyTYnmk4NjRbi0%2FLtgPt76UYiv2zJW06SpKlzkwtGyNSEeZ4EHt%2BC14yYroybU4tDHPjnjpGt1%2FS1JLEHI%2BEIefBRuPsNFh9XQeG0oPEuQGHydZvdlBhkBDbkyYT9DTzOuES1suOlukXmWn4Qo168OuqA%3D%3D',
    impact: 0,
    interacted_page_id: '196008906145',
    interactions: 67,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 47,
    location: '',
    long_posted_at: 1774395666000,
    long_updated_at: 1774396828406,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [],
    metrics_updated_at: '24/03/2026 21:00',
    name: 'Hugo Gloss',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '196008906145',
    pages: [
      '196008906145'
    ],
    pid: '1568404514843820',
    polarity: 0,
    post_url: 'https://www.facebook.com/858693865814892/posts/1568404514843820',
    post_user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    posted_at: '24/03/2026 20:41',
    primary_channel: 'Facebook',
    reaction_angry: 2,
    reaction_haha: 0,
    reaction_like: 47,
    reaction_love: 12,
    reaction_pride: 0,
    reaction_sad: 3,
    reaction_thankful: 0,
    reaction_total: 64,
    reaction_wow: 0,
    reactions: 64,
    replied: false,
    reply_pid: '1568404514843820',
    shares: 1,
    spam: false,
    spokesman: [],
    status: 'Pendente',
    tags: [
      'IMAGE-RECOGNITION-SERVICE'
    ],
    terms: [],
    text: 'Os seis suspeitos continuam presos. Saiba os detalhes do caso:<br><br>Os seis suspeitos por espancarem a <b>capivara</b> est\u00e3o presos, e v\u00e3o responder por maus-tratos, associa\u00e7\u00e3o criminosa e corrup\u00e7\u00e3o de menores.<br><br>Homens acusados de espancar <b>capivara</b> no RJ s\u00e3o enquadrados no Decreto C\u00e3o Orelha, e Ibama anuncia medida - Hugo Gloss',
    theme_polarity: [],
    themes: [],
    title: 'Homens acusados de espancar capivara no RJ s\u00e3o enquadrados no Decreto C\u00e3o Orelha, e Ibama anuncia medida - Hugo Gloss',
    type: 'image',
    uid: '196008906145',
    update_time_ago: '2 meses atr\u00e1s',
    user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/196008906145',
    username: 'HugoGloss',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '1566560708361534_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1566560708361534',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1566560708361534/1566560708361534',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1566560708361534/1566560708361534?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=cuDlhs7ASdJpyXVdiZhn%2FlPmAxr4DWpV2MnvrGEXcSTXGugIaesWGyPEPIGYqA2CcOFx793gyoM%2BOBUEv4bRI%2BWyGcEg8u1tWInx6y8CcEWtNaK%2Fn8lL9OKtUOB%2F4OIjznE9Ju%2FPkYz%2B7qZeIiFFMPz3128LQdtf2ufNtgypHXF5eOe6agYmFE7k1JVK4pQPIZCftB4vEJV77vC84aPIyMVgcqu0B9RgZa3yRNRir5BzUY3TM3J%2BxxY1J6E9eNxnVTRQKVDhjTosDHrSNMhvQm1D7srpEdBJIUAFqNUc6qyLFXHPm%2F1fqYRk3adLfiwbYSNle7DWmvKKHLUDyohPpQ%3D%3D',
        type: 'image/jpeg',
        url: 'https://scontent-iad3-2.xx.fbcdn.net/v/t51.82787-15/655250212_18635276815060946_3984219198199408504_n.jpg?stp=dst-jpg_p720x720_tt6&_nc_cat=1&ccb=1-7&_nc_sid=13d280&_nc_eui2=AeFvHlho_l_7g7bbH_s6WQFU2QP0v8FnEJnZA_S_wWcQmX_bIr4zTMRWvCFM98IJkwEv9-ew1daGiengb7eEhCBK&_nc_ohc=yjqfjLdRXCcQ7kNvwGKYKy9&_nc_oc=AdrqF8JjUQRE_AghAjPz5ZO0hShaMj8Z2WlE_eGpw5RIgxrj05oj0GKI83uZHXiSGgU&_nc_zt=23&_nc_ht=scontent-iad3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=sQAvzPFAnAQtDUUZqhBBYA&_nc_tpa=Q5bMBQEaOF2x15wiEUZB_nCcad4f0ZwtJS8uVhsZHGxtOxX-SKrW34HR4PBsRi3zUWlpCalx1b8hYzdU&oh=00_AfzBN4B2sy8WY_r9afBNueisV5YgOYiVxMf4iPfBwe1NWQ&oe=69C5F705'
      }
    ],
    authors: [],
    channel: 'Facebook',
    comments: 48,
    computer_vision: {
      has_image_text: true,
      text: 'veterinario atualiza estado de saude de <b>capivara</b> agredida por grupo de 8 pessoas no rj e testemunha revela detalhe he sobre suspeito hugo gloss'
    },
    contact_reasons: [],
    crawled_at: 1774205926834,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: 'Homem',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [],
    hidden_by_user: false,
    hot: 2670.9838037214813,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1566560708361534/1566560708361534?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=cuDlhs7ASdJpyXVdiZhn%2FlPmAxr4DWpV2MnvrGEXcSTXGugIaesWGyPEPIGYqA2CcOFx793gyoM%2BOBUEv4bRI%2BWyGcEg8u1tWInx6y8CcEWtNaK%2Fn8lL9OKtUOB%2F4OIjznE9Ju%2FPkYz%2B7qZeIiFFMPz3128LQdtf2ufNtgypHXF5eOe6agYmFE7k1JVK4pQPIZCftB4vEJV77vC84aPIyMVgcqu0B9RgZa3yRNRir5BzUY3TM3J%2BxxY1J6E9eNxnVTRQKVDhjTosDHrSNMhvQm1D7srpEdBJIUAFqNUc6qyLFXHPm%2F1fqYRk3adLfiwbYSNle7DWmvKKHLUDyohPpQ%3D%3D',
    impact: 0,
    interacted_page_id: '196008906145',
    interactions: 441,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 195,
    location: '',
    long_posted_at: 1774204829000,
    long_updated_at: 1778335740000,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [],
    metrics_updated_at: '09/05/2026 11:09',
    name: 'Hugo Gloss',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '196008906145',
    pages: [
      '196008906145'
    ],
    pid: '1566560708361534',
    polarity: 0,
    post_url: 'https://www.facebook.com/858693865814892/posts/1566560708361534',
    post_user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    posted_at: '22/03/2026 15:40',
    primary_channel: 'Facebook',
    reaction_angry: 72,
    reaction_haha: 0,
    reaction_like: 195,
    reaction_love: 3,
    reaction_pride: 0,
    reaction_sad: 111,
    reaction_thankful: 0,
    reaction_total: 385,
    reaction_wow: 4,
    reactions: 385,
    replied: false,
    reply_pid: '1566560708361534',
    shares: 8,
    spam: false,
    spokesman: [],
    status: 'Pendente',
    tags: [],
    terms: [],
    text: 'O veterin\u00e1rio que atendeu a <b>capivara</b> agredida por um grupo na Ilha do Governador atualizou o estado de sa\u00fade do animal. Ontem (21), o roedor havia chegado em estado grave ao Centro de Recupera\u00e7\u00e3o de Animais Silvestres. Al\u00e9m do profissional, uma testemunha tamb\u00e9m se manifestou ao @jornaloglobo e revelou um detalhe chocante sobre um dos suspeitos. A pol\u00edcia ainda apontou que o caso pode se tornar o primeiro a aplicar o novo decreto conhecido como "Justi\u00e7a por Orelha".<br><br>\u27a1\ufe0f Saiba os detalhes: https://gloss.bz/4uLz0qG<br><br>(\ud83d\udcf8: Reprodu\u00e7\u00e3o/TV Globo)<br><br>Fotos do post de Hugo Gloss',
    theme_polarity: [],
    themes: [],
    title: 'Fotos do post de Hugo Gloss',
    type: 'image',
    uid: '196008906145',
    update_time_ago: 'Nunca editado',
    user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/196008906145',
    username: 'HugoGloss',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '1566558335028438_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1566558335028438',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1566558335028438/1566558335028438',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1566558335028438/1566558335028438?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=VjkdBF0ooNqTmcDMq5J6VH%2F3ksnJWaEjvB%2FOKb1FmndrbJ6V6Dt4DWrE450iWnvRrpdIDHx4cW%2FIbYjGrV%2BXMgw6RaZVYHGVVkLgwQrImzXVyErC6PZK%2B0L71D%2FavA9TXtAzW%2FmSLAQlBYyDIzLgjGwIQuWDW9lFMNGNsnHMfB5%2B6MkmlPVFo6sz0SHBypKwSP9AwMU5GhPJ6Znh3IFpD4tneGa3P9pyJU74FYEp4UQzycsv7XmtXNIrFDhC5ZIylEBrYEVzM8QFsZAaEaohhhWN%2Bhh2l8zUTDuKB%2Bxf3ticn0lWPLLoMInv3EPuh%2F50qmFalksypjhsu8HcY9oBeA%3D%3D',
        type: 'image/jpeg',
        url: 'https://external-iad3-2.xx.fbcdn.net/emg1/v/t13/6984560260010960661?url=https%3A%2F%2Fmedia.hugogloss.uol.com.br%2Fuploads%2F2026%2F03%2Fcapivara-foto_-reproducao_g1-1.jpg&fb_obo=1&utld=uol.com.br&stp=c0.5000x0.5000f_dst-emg0_p720x720_q75_tt6&edm=AKIiGfEEAAAA&_nc_gid=qkR81fj-cuVlkax20c2_VQ&_nc_oc=AdrCzPUAONv6ufzgVoQn9Xj9zdDOakA8DSxZK67YFUkUUlyAcQbnjLgwnoz3NIiki_w&ccb=13-1&oh=06_Q3-9AWp2siJPbwXZFZEb01GoMb8F2px9ZwBoW-qpgl5sMyY3&oe=69C21FB7&_nc_sid=ef6713'
      }
    ],
    authors: [],
    channel: 'Facebook',
    comments: 2,
    computer_vision: {
      has_image_text: true,
      text: 'im 14'
    },
    contact_reasons: [],
    crawled_at: 1774204722093,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: 'Homem',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [],
    hidden_by_user: false,
    hot: 2669.3610262503835,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1566558335028438/1566558335028438?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=VjkdBF0ooNqTmcDMq5J6VH%2F3ksnJWaEjvB%2FOKb1FmndrbJ6V6Dt4DWrE450iWnvRrpdIDHx4cW%2FIbYjGrV%2BXMgw6RaZVYHGVVkLgwQrImzXVyErC6PZK%2B0L71D%2FavA9TXtAzW%2FmSLAQlBYyDIzLgjGwIQuWDW9lFMNGNsnHMfB5%2B6MkmlPVFo6sz0SHBypKwSP9AwMU5GhPJ6Znh3IFpD4tneGa3P9pyJU74FYEp4UQzycsv7XmtXNIrFDhC5ZIylEBrYEVzM8QFsZAaEaohhhWN%2Bhh2l8zUTDuKB%2Bxf3ticn0lWPLLoMInv3EPuh%2F50qmFalksypjhsu8HcY9oBeA%3D%3D',
    impact: 0,
    interacted_page_id: '196008906145',
    interactions: 7,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 4,
    location: '',
    long_posted_at: 1774204578000,
    long_updated_at: 1774204735010,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [],
    metrics_updated_at: '22/03/2026 15:38',
    name: 'Hugo Gloss',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '196008906145',
    pages: [
      '196008906145'
    ],
    pid: '1566558335028438',
    polarity: 0,
    post_url: 'https://www.facebook.com/858693865814892/posts/1566558335028438',
    post_user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    posted_at: '22/03/2026 15:36',
    primary_channel: 'Facebook',
    reaction_angry: 0,
    reaction_haha: 0,
    reaction_like: 4,
    reaction_love: 0,
    reaction_pride: 0,
    reaction_sad: 1,
    reaction_thankful: 0,
    reaction_total: 5,
    reaction_wow: 0,
    reactions: 5,
    replied: false,
    reply_pid: '1566558335028438',
    shares: 0,
    spam: false,
    spokesman: [],
    status: 'Pendente',
    tags: [
      'IMAGE-RECOGNITION-SERVICE'
    ],
    terms: [],
    text: 'O caso pode se tornar o primeiro a aplicar o novo decreto conhecido como "Justi\u00e7a por Orelha". Entenda:<br><br>Caso pode se tornar o primeiro a aplicar o novo decreto conhecido como "Justi\u00e7a por Orelha"<br><br>Veterin\u00e1rio atualiza estado de sa\u00fade de <b>capivara</b> agredida por grupo de 8 pessoas no RJ, e testemunha revela detalhe sobre suspeito - Hugo Gloss',
    theme_polarity: [],
    themes: [],
    title: 'Veterin\u00e1rio atualiza estado de sa\u00fade de capivara agredida por grupo de 8 pessoas no RJ, e testemunha revela detalhe sobre suspeito - Hugo Gloss',
    type: 'image',
    uid: '196008906145',
    update_time_ago: '2 meses atr\u00e1s',
    user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/196008906145',
    username: 'HugoGloss',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '1565829061768032_Facebook',
    attachments: [
      {
        attachment_type: 'post',
        id: '1565829061768032',
        media_type: 'IMAGE',
        name: 'facebook_image',
        storage_id: 'facebook/post/1565829061768032/1565829061768032',
        storage_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1565829061768032/1565829061768032?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=STK82A4D%2F8p7X0I8pXB2N2oScuE1GrgknkXixqfUCdHJNc5XhGWaaWu5U3c1DY7IcLCvMlQzbUEqNMehOq8UyrFY1%2BMrBpCXWRVcNKdH4t5coEfeMuLqyrXC3QO20G%2FQqa5Lo71Ff0VMAbH%2FALSPE6uu%2FFQq%2FbMJhlVPNnauPNILVyqku1R3Uvud%2FRwvquvpAMdwFWd4rJhgr0NSlU36lkoRw75hV06%2B6QNgDiwvQ92mUccgn1QhkcIG1dMSHJa5sjJHF%2FpIkY95lx9pyN2ruU%2BTrwJ9iUpVLn8%2BnL1SeZqSkfoi4m5w1%2F9S6f4e9B%2Fdy7xu8VM6ygaAbplR6QDFmA%3D%3D',
        type: 'image/jpeg',
        url: 'https://scontent-iad3-2.xx.fbcdn.net/v/t51.82787-15/655220635_18634916002060946_6621838205017005154_n.jpg?stp=dst-jpg_p720x720_tt6&_nc_cat=1&ccb=1-7&_nc_sid=13d280&_nc_eui2=AeECHOQ7iXGQ0guLsuirr_D-5sIVCGJcP1PmwhUIYlw_U4rcVIpZRZucMPbc7iisaVg&_nc_ohc=D1sYyUqn8TcQ7kNvwFCHzb1&_nc_oc=AdoU0cg3OGxaqV9NWSrVMMswXTrtn_VIRv4PgM4KxYS2IMSfb80WJah2nyflaxWL3Oo&_nc_zt=23&_nc_ht=scontent-iad3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=sS2RmYQ9eJWmJA991tsoNA&_nc_tpa=Q5bMBQHvKoDoPl5dHUZ25_B8jpOa98CpxYrOTB6foD99VGVXof0lN3DvQkBlqEO0E0JakJ-yl8S7Fua2&oh=00_AfzOc2XmHLibXMCPE64vWP_4WaVyII0eeRKNCnxYRhDHSA&oe=69C4F59C'
      }
    ],
    authors: [],
    channel: 'Facebook',
    comments: 22,
    computer_vision: {
      has_image_text: true,
      text: '<b>capivara</b> e espancada por grupo de 8 pessoas no rj eimagens chocami suspeitos sao presos hugo gloss 14'
    },
    contact_reasons: [],
    crawled_at: 1774133606503,
    critical_level: 0,
    dislikes: 0,
    emotion: '',
    favorability: [],
    favorite: false,
    features: [],
    followers: 0,
    footage: 0,
    from_integration: false,
    gender: 'Homem',
    group_polarity: [
      {
        group: 'Capivara',
        polarity: 0
      }
    ],
    hashtags: [],
    hidden_by_user: false,
    hot: 2669.8278399913283,
    hot_post: false,
    image_url: 'https://storage.googleapis.com/stilingue-images-staging/facebook/post/1565829061768032/1565829061768032?GoogleAccessId=storage-service-staging@cloudstorage-staging.iam.gserviceaccount.com&Expires=1779065468&Signature=STK82A4D%2F8p7X0I8pXB2N2oScuE1GrgknkXixqfUCdHJNc5XhGWaaWu5U3c1DY7IcLCvMlQzbUEqNMehOq8UyrFY1%2BMrBpCXWRVcNKdH4t5coEfeMuLqyrXC3QO20G%2FQqa5Lo71Ff0VMAbH%2FALSPE6uu%2FFQq%2FbMJhlVPNnauPNILVyqku1R3Uvud%2FRwvquvpAMdwFWd4rJhgr0NSlU36lkoRw75hV06%2B6QNgDiwvQ92mUccgn1QhkcIG1dMSHJa5sjJHF%2FpIkY95lx9pyN2ruU%2BTrwJ9iUpVLn8%2BnL1SeZqSkfoi4m5w1%2F9S6f4e9B%2Fdy7xu8VM6ygaAbplR6QDFmA%3D%3D',
    impact: 0,
    interacted_page_id: '196008906145',
    interactions: 87,
    is_dynamic_post: false,
    is_hidden: false,
    lang: 'pt',
    likes: 16,
    location: '',
    long_posted_at: 1774133159000,
    long_updated_at: 1774133632007,
    max_shared_followers: 0,
    max_shared_show_dossier: false,
    mentions: [],
    metrics_updated_at: '21/03/2026 19:53',
    name: 'Hugo Gloss',
    names: [
      'Capivara'
    ],
    occupations: [],
    order_by: 'date_desc',
    page_comment: true,
    page_id: '196008906145',
    pages: [
      '196008906145'
    ],
    pid: '1565829061768032',
    polarity: 0,
    post_url: 'https://www.facebook.com/858693865814892/posts/1565829061768032',
    post_user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    posted_at: '21/03/2026 19:45',
    primary_channel: 'Facebook',
    reaction_angry: 35,
    reaction_haha: 0,
    reaction_like: 16,
    reaction_love: 0,
    reaction_pride: 0,
    reaction_sad: 12,
    reaction_thankful: 0,
    reaction_total: 63,
    reaction_wow: 0,
    reactions: 63,
    replied: false,
    reply_pid: '1565829061768032',
    shares: 2,
    spam: false,
    spokesman: [],
    status: 'Pendente',
    tags: [
      'IMAGE-RECOGNITION-SERVICE'
    ],
    terms: [],
    text: 'Um grupo de oito pessoas foi detido ap\u00f3s agredir uma <b>capivara</b> na Ilha do Governador, na Zona Norte do Rio de Janeiro. O caso aconteceu na madrugada deste s\u00e1bado (21) e foi registrado por c\u00e2meras de seguran\u00e7a. As imagens, divulgadas pelo @portalg1, mostraram a sequ\u00eancia da a\u00e7\u00e3o. Ap\u00f3s a repercuss\u00e3o, os envolvidos foram presos e as autoridades revelaram o estado de sa\u00fade do animal.<br><br>\u27a1\ufe0f Assista e saiba os detalhes: https://gloss.bz/480tBC9<br><br>(\ud83d\udcf8: Reprodu\u00e7\u00e3o/TV Globo)<br><br>Fotos do post de Hugo Gloss',
    theme_polarity: [],
    themes: [],
    title: 'Fotos do post de Hugo Gloss',
    type: 'image',
    uid: '196008906145',
    update_time_ago: '2 meses atr\u00e1s',
    user_image_url: 'https://scontent-mia3-2.xx.fbcdn.net/v/t39.30808-1/526769056_1377440890606851_8310557611271171188_n.jpg?stp=cp1_dst-jpg_s50x50_tt6&_nc_cat=1&ccb=1-7&_nc_sid=f907e8&_nc_eui2=AeEyrjbWFFmU02Ve7Sg7bxLmLaMuQRTpUz0toy5BFOlTPepC2paMxfJGIJVOWXowktG-fTiByvKohiPMdltOaKmo&_nc_ohc=q8pEfCBP3QAQ7kNvwHCEKuk&_nc_oc=AdoBjMZqWWiOio1BxW0fb6KupG4clYkKhZtn85ZneW2WALrl_oUMscGEQ5ArGnfUgKE&_nc_zt=24&_nc_ht=scontent-mia3-2.xx&edm=AKIiGfEEAAAA&_nc_gid=prOLNSVAnikyF2tKl1CPxQ&_nc_tpa=Q5bMBQGaE7e584pYLkA-Wv6AMgn8RvpOxLRX5ipa-rK2ubJT15jzr8pJZk1tbAGV97h6L5vsRBS08WrV&oh=00_AfxhXd3R_mApK1CelWSdmHvoJMo8Jhg50_CJO9eZVWxhAw&oe=69C90F59',
    user_score: 0.01,
    user_url: 'https://www.facebook.com/196008906145',
    username: 'HugoGloss',
    valoration: 0,
    verified: false,
    videoplays: 0
  },
  {
    _id: '2100915452813692928_TwitterInbox',
    pid: '2100915452813692928',
    hot_post: false,
    text: 'CwABAAAAEzIwOTM0MDczMjQwNjA2OTI0ODALAAIAAAAkYjI4MDZmNjQtOWZjOC00OWQwLTkyYWYtNDk1MTU2ZTFkMzk0CwADAAAACDI4NjQxNzg2CwAEAAAAGzI4NjQxNzg2OjgwMzIzMzEwMjM3ODE4ODgwMQsABQAAAMdleUpoYkdjaU9pSklVekkxTmlKOS5leUp5WlhGMVpYTjBhVzVuVlhObGNpSTZJQ0l5T0RZME1UYzROaUlzSUNKeVpXTnBjR2xsYm5RaU9pQWlPREF6TWpNek1UQXlNemM0TVRnNE9EQXhJaXdnSW5aaGJHbGtVMmx1WTJWTlUyVmpJam9nSWpFM05EVTRPRFE0TURBd01EQWlmUS5EbVZEdk81cFJ1M2x2cUE4Z2hRODhmSml0cGU4Xzh6aTVxZHRPdnllNUxnCwAGAAAADTE3ODc5NDIxNzQzNDAMAAcMAAwLAAEAAAATMjAxNjg4MDU2NTg5MTI4NTI0MwoAAgAAAaBJqH4LAAAIAAgAAAABDAAJCwABAAAAVmcxVVFTVUtKWXRGaHViUHRlY3dVc1NIbU5jL1lyL2h0eDNONi85anB4R3JSYld3NEhId1dsakxqUS9hT3d5cU1VTUthKzE0MjU3Z3QzZ3E0WkM4R2pRCwACAAAADTE3Njc3MzAxOTE4MzELAAMAAAABNwsABAAAAHxNRmt3RXdZSEtvWkl6ajBDQVFZSUtvWkl6ajBEQVFjRFFnQUVOUzFjU1duYVVXM2hRR1RTVW9sZHQ4bE5Hd1VZNW9JQ1BNNmphUHpFbys4UEN1TWVUTHByZzNHVUpMK0ZvOUYvcGlwL0Zwd0hIWEo2c3d5QmVKeHp1QT09DwAFDAAAAAELAAEAAAAIMjg2NDE3ODYLAAIAAAANMTc2NzczMDE5MTgzMQsAAwAAAHxNRmt3RXdZSEtvWkl6ajBDQVFZSUtvWkl6ajBEQVFjRFFnQUVOUzFjU1duYVVXM2hRR1RTVW9sZHQ4bE5Hd1VZNW9JQ1BNNmphUHpFbys4UEN1TWVUTHByZzNHVUpMK0ZvOUYvcGlwL0Zwd0hIWEo2c3d5QmVKeHp1QT09AAACAAsBAA==',
    title: '',
    name: 'Nando Coelho',
    post_url: 'https://twitter.com/messages/4849697969:1554165413218603012',
    likes: 0,
    dislikes: 0,
    reactions: 0,
    shares: 0,
    comments: 0,
    videoplays: 0,
    interactions: 0,
    followers: 13,
    hot: 2746.221243645,
    verified: false,
    uid: '4849697969',
    user_score: 0.01,
    occupations: [
      'agora parece q tá anotando interesse novo de boa',
      'spotify',
      'Cursos de bitoneteiro'
    ],
    username: 'mim_noc',
    user_url: 'https://www.twitter.com/mim_noc',
    gender: 'Homem',
    polarity: 3,
    location: '',
    themes: [
      'teste8'
    ],
    critical_level: 3,
    theme_polarity: [
      {
        theme: 'teste8_1649433',
        polarity: 0
      }
    ],
    names: [],
    group_polarity: [],
    channel: 'Inbox do Twitter',
    long_posted_at: 1789732251729,
    posted_at: '18/09/2026 08:50',
    metrics_updated_at: '18/09/2026 08:51',
    hashtags: [],
    mentions: [],
    tags: [
      'medio-influenciador'
    ],
    contact_reasons: [],
    favorite: false,
    spam: false,
    replied: false,
    type: 'image',
    update_time_ago: '4 dias atrás',
    long_updated_at: 1789732280005,
    from_integration: false,
    status: 'Pendente',
    hidden_by_user: false,
    pages: [
      '1554165413218603012'
    ],
    primary_channel: 'Twitter',
    sac_type: 'Inbox',
    reply_pid: '2100915452813692928',
    sac_call_id: '1554165413218603012_4849697969',
    page_comment: false,
    page_id: '1554165413218603012',
    image_url: 'https://storage.googleapis.com/imagesstilingue/twitter/inbox/2100915452813692928/f3be2122-bc6d-4b63-82e9-96fd6ed00d5d?GoogleAccessId=storage-manager@cloudstorage-220220.iam.gserviceaccount.com&Expires=1790688629&Signature=ANc%2FT2sZqP0qO%2BTx4iezqTmOsmmxz4xJpfpS7NFPUO7Lhf3j82eldJV7w79OCfSvrwq9r%2FzZN7WpfeVzE0RaO9SIrM89VTV6BfDaL%2Bx%2Fe6mIvgsuASy%2BRwBpJRG3mQdTfLV%2Bh2VJrOM6giq1vIgo8U%2FiD1pgrTA5%2FANJ1E0aOACsK1E7UZDAvTynOa9r13T8thxbX8jyyN05LQJfSbA%2Fp9fNznuvH3zGo7w1UJesRd29eXyR%2BIeQ3AsNbrSH98XXE2kESn0FzQiFSL91zJGae5coImhsGsmhYYB0Ek55DLNn1am%2BE1mxjSKT40y6pp%2Fc2BYx1RZmXnmOzmpizVE77w%3D%3D',
    attachments: [
      {
        media_type: 'IMAGE',
        type: 'image/jpeg',
        name: 'giphy.gif',
        url: 'https://storage.googleapis.com/imagesstilingue/twitter/inbox/2100915452813692928/f3be2122-bc6d-4b63-82e9-96fd6ed00d5d',
        id: 'f3be2122-bc6d-4b63-82e9-96fd6ed00d5d',
        storage_url: 'https://storage.googleapis.com/imagesstilingue/twitter/inbox/2100915452813692928/f3be2122-bc6d-4b63-82e9-96fd6ed00d5d?GoogleAccessId=storage-manager@cloudstorage-220220.iam.gserviceaccount.com&Expires=1790688629&Signature=ANc%2FT2sZqP0qO%2BTx4iezqTmOsmmxz4xJpfpS7NFPUO7Lhf3j82eldJV7w79OCfSvrwq9r%2FzZN7WpfeVzE0RaO9SIrM89VTV6BfDaL%2Bx%2Fe6mIvgsuASy%2BRwBpJRG3mQdTfLV%2Bh2VJrOM6giq1vIgo8U%2FiD1pgrTA5%2FANJ1E0aOACsK1E7UZDAvTynOa9r13T8thxbX8jyyN05LQJfSbA%2Fp9fNznuvH3zGo7w1UJesRd29eXyR%2BIeQ3AsNbrSH98XXE2kESn0FzQiFSL91zJGae5coImhsGsmhYYB0Ek55DLNn1am%2BE1mxjSKT40y6pp%2Fc2BYx1RZmXnmOzmpizVE77w%3D%3D',
        storage_id: 'twitter/inbox/2100915452813692928/f3be2122-bc6d-4b63-82e9-96fd6ed00d5d'
      }
    ],
    is_dynamic_post: false,
    lang: 'pt',
    crawled_at: 1789732268527,
    features: [
      'ENCRYPTED'
    ],
    user_image_url: 'https://pbs.twimg.com/profile_images/692429611515449346/S5R9qR4q_normal.jpg',
    post_user_image_url: 'https://pbs.twimg.com/profile_images/692429611515449346/S5R9qR4q_normal.jpg',
    order_by: 'hot',
    terms: [
      'Certo',
      'Pin'
    ]
  },
];
